<template>
    <div class="booking-manager-container">
        <div class="event-list">
            <div class="d-flex justify-content-between align-items-center header-block">
                <div class="d-flex w-100 mt-5 mb-2 header-wrapper">
                    <h1 class="page-title">My Events</h1>
                    <button
                        v-if="width > 600"
                        ref="openModal"
                        @click="checkAvails"
                        class="check-avails"
                    >
                        Create Events
                    </button>
                </div>
                <b-modal
                    no-enforce-focus
                    centered
                    id="modal-create-event"
                    size="xl"
                    tabindex=""
                    content-class="modal-create-event"
                >
                    <template #modal-header>
                        <div class="new-design-header">
                            <button
                                v-if="modalStep !== 1 && modalStep !== 5"
                                @click="goBackStep"
                                class="back-btn"
                            >
                                <img
                                    :src="getIcon() + 'left-arrow-yellow.svg'"
                                    class="back-btn-icon"
                                    alt="back-arrow"
                                />
                            </button>
                            <p
                                :style="modalStep === 1 ? { 'margin-left': 'auto' } : {}"
                                class="create-event-title"
                            >
                                Create Events
                            </p>
                        </div>
                        <div
                            v-if="modalStep !== 5"
                            @click="closeModal"
                            class="close-modal-event"
                        >
                            <p class="cancel-btn-label">Cancel</p>
                            <img
                                class="cancel-icon"
                                :src="getIcon() + 'close-event-modal-yellow.svg'"
                            />
                        </div>
                    </template>
                    <template>
                        <div class="d-flex flex-column w-100" v-if="modalStep === 1">
                            <div class="text-start">
                                <h2 class="modal-event-title">Let’s set some dates</h2>
                                <p class="modal-event-text modal-subtitle">
                                    Select one or more dates you’re looking to book artists
                                    for, and we’ll create events for each date.
                                </p>
                                <div class="mb-4"></div>
                                <div class="mb-2"></div>
                            </div>
                            <div>
                                <CheckAvailsCalendar
                                    ref="calendarForm"
                                    :selected-dates="formattedSelectedDates"
                                    :events="getAllCalendarEvents"
                                    :subPlan="subscriptionPlan"
                                    :actualEvents="actualEventNumber"
                                    :disableCreateEventBtn.sync="disableCreateEventBtn"
                                    @update-selected-dates="handleUpdateSelectedDates"
                                    @selected-count="handleTotalCount"
                                />
                            </div>
                        </div>
                        <div v-if="modalStep === 6" class="d-flex flex-column w-100">
                            <div class="text-start modal-contents-main">
                                <p class="modal-event-title gray-text pb-3">
                                    {{ dateLanguage }}
                                    {{ selectedDatesFormatted(selectedDates) }}
                                </p>
                                <SelectVenueAddress
                                    @selected-venue="handleSelectedVenue"
                                    :booker="booker"
                                    :selected="selectedVenue"
                                />
                            </div>
                        </div>
                        <div v-if="modalStep === 2" class="d-flex flex-column w-100">
                            <div class="text-start modal-contents-main">
                                <p class="modal-event-title gray-text pb-3">
                                    {{ dateLanguage }}
                                    {{ selectedDatesFormatted(selectedDates) }}
                                </p>
                                <p
                                    v-if="selectedVenue"
                                    class="modal-event-title gray-text pb-3"
                                >
                                    {{ `Venue: ${selectedVenue.venue_name}` }}
                                </p>
                                <p class="modal-event-title">What’s the vibe?</p>
                                <div class="opportunity-detail-input-wrapper">
                                    <p class="modal-event-text">
                                        Provide details of the opportunity so artists know what
                                        to expect when they apply.
                                    </p>
                                    <p
                                        class="details-wordcount modal-event-text"
                                        :class="
                                            opportunityDetail.length > 500 ? 'error-msg' : ''
                                        "
                                    >
                                        {{ opportunityDetailWordCount }}
                                    </p>
                                </div>
                                <textarea
                                    v-model="opportunityDetail"
                                    class="opportunity-detail-input mb-2"
                                    placeholder="Add details of this opportunity like desired duration, start time, any restrictions or other info that is useful for talent to apply."
                                    name="opportunity_detail"
                                    cols="30"
                                    rows="10"
                                ></textarea>
                                <p
                                    v-if="opportunityDetail.length > 500"
                                    class="mb-0 error-msg"
                                >
                                    You have exceeded the maximum number of characters in this
                                    text field.
                                </p>
                                <p class="modal-event-text">
                                    Now let's add some keywords to help match you with the
                                    right artists.
                                </p>
                                <div>
                                    <AddEventTags
                                        ref="eventTagsModal"
                                        :eventTags.sync="eventTags"
                                        :locateTags="locateTags"
                                        :mode="mode"
                                        :width="width"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="modalStep === 3" class="d-flex flex-column w-100">
                            <div class="text-start modal-contents-main">
                                <p class="modal-event-title gray-text">
                                    {{ dateLanguage }}
                                    {{ selectedDatesFormatted(selectedDates) }}
                                </p>
                                <p
                                    v-if="selectedVenue"
                                    class="modal-event-title gray-text pb-3"
                                >
                                    {{ `Venue: ${selectedVenue.venue_name}` }}
                                </p>
                                <p class="modal-event-title gray-subtitle multi-line">
                                    {{ opportunityDetail }}
                                </p>
                                <div class="vibe-pills-wrapper pb-3">
                                    <p
                                        v-for="(vibe, indx) in getTags.split(', ')"
                                        :key="indx"
                                        class="modal-event-title gray-subtitle vibe-pills"
                                    >
                                        {{ vibe }}
                                    </p>
                                </div>
                                <p class="modal-event-title">
                                    How much would you like to pay the artist?
                                </p>
                                <div class="payout-input-wrapper">
                                    <div class="payout-switch-label">
                                        <span class="switch-label">
                                            I don't have a budget
                                        </span>
                                        <SwitchToggle
                                            :initialState="hidePayout"
                                            @switch-checked="hidePayoutInput"
                                            @switch-unchecked="showPayoutInput"
                                        />
                                    </div>
                                    <div v-if="!hidePayout" class="budget-input">
                                        <label for="payout-budget" class="label-value"
                                            >Desired Payout</label
                                        >
                                        <span class="budget-value-input">
                                            <span v-if="eventBudget !== ''">$</span>
                                            <input
                                                v-model="eventBudget"
                                                class="budget-value"
                                                type="number"
                                                placeholder="$1000"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="line-chart-container position-relative">
                                <!-- Hide linechart according to ticket 2175 -->
                                <div class="d-none">
                                    <LineChart
                                        ref="eventBudgetModal"
                                        :width="440"
                                        :events="transformedEventsForBudget"
                                        :selectedDataLine="chartLineBar"
                                        :selectedOptionsLine="chartOptions"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-if="modalStep === 4" class="d-flex flex-column w-100">
                            <div class="text-start modal-contents-main">
                                <p class="modal-event-title gray-text">
                                    {{ dateLanguage }}
                                    {{
                                        selectedDates
                                            ? selectedDatesFormatted(selectedDates)
                                            : eventDate
                                    }}
                                </p>
                                <p
                                    v-if="selectedVenue"
                                    class="modal-event-title gray-text pb-3"
                                >
                                    {{ `Venue: ${selectedVenue.venue_name}` }}
                                </p>
                                <p class="modal-event-title gray-subtitle multi-line">
                                    {{ opportunityDetail }}
                                </p>
                                <div
                                    v-if="getTags || eventVibe.length"
                                    class="vibe-pills-wrapper pb-3"
                                >
                                    <p
                                        v-for="(vibe, indx) in getTags
                                            ? getTags.split(', ')
                                            : eventVibe"
                                        :key="indx"
                                        class="modal-event-title gray-subtitle vibe-pills"
                                    >
                                        {{ vibe }}
                                    </p>
                                </div>
                                <p
                                    v-if="!eventBudget || eventBudget === '0.00'"
                                    class="modal-event-title gray-text"
                                >
                                    Desired Payout: N/A
                                </p>
                                <p v-else class="modal-event-title gray-text">
                                    Desired Payout: {{ `Up to $${eventBudget}` }}
                                </p>
                            </div>
                            <div class="d-flex flex-column text-start">
                                <p class="modal-event-title py-3">Let’s invite some artists</p>
                                <div class="event-type-input-wrapper">
                                    <div class="event-type-switch-label">
                                        <span class="switch-label"> Private </span>
                                        <SwitchToggle
                                            :initialState="privateOpportunity"
                                            @switch-checked="setPrivateOpportunity"
                                            @switch-unchecked="setPublicOpportunity"
                                        />
                                    </div>
                                    <p
                                        v-if="!privateOpportunity"
                                        class="invite-artist-description gray-text mb-0"
                                    >
                                        Open to all Hedlyner Artists
                                    </p>
                                    <p v-else class="invite-artist-description gray-text mb-0">
                                        Only artists with a link can see the event
                                    </p>
                                </div>
                                <div class="pb-1"></div>
                                <div class="pb-4"></div>
                                <div
                                    v-if="venueContacts.length"
                                    class="invite-artist-content d-flex flex-wrap align-items-center"
                                >
                                    <p class="invite-artist-list">
                                        Invite relevant artists from:
                                    </p>
                                    <div
                                        v-if="venueContacts.length"
                                        @click="handleSelectAllContacts"
                                    >
                                        <p
                                            :class="
                                                contactSelected
                                                    ? 'contact-artist-selected'
                                                    : 'contact-artist'
                                            "
                                        >
                                            <img
                                                v-if="contactSelected"
                                                :src="getIcon() + 'selected-icon.png'"
                                            />
                                            My Contacts
                                            {{ venueContacts.length }}
                                        </p>
                                    </div>
                                </div>
                                <hr style="color: #646464; height: 2px" />
                                <div class="specific-artists">
                                    <div class="d-flex specific-artists-content">
                                        <p class="invite-artist">Invite specific artists:</p>
                                        <div
                                            v-if="inviteSpecialArtist.length"
                                            class="d-flex align-items-center pills-container"
                                        >
                                            <div
                                                v-for="(artist, index) in getInvitedArtist"
                                                :key="index"
                                                class="d-flex align-items-center artists-pills"
                                            >
                                                <p v-if="artist.name">{{ artist.name }}</p>
                                                <p v-else>{{ artist.email }}</p>
                                                <p
                                                    class="remove-email"
                                                    @click="removeEmail(index)"
                                                >
                                                    x
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="enter-artists">
                                        <input
                                            v-model="artistsData"
                                            placeholder="Add emails separated by commas"
                                            @keyup.enter="addArtists"
                                            @keydown="() => setContactsDropdown(false)"
                                            @click="() => setContactsDropdown(true)"
                                        />
                                        <button
                                            @click="addArtists"
                                            :class="{ 'disabled-invite-btn': !artistsData }"
                                        >
                                            Add
                                        </button>
                                        <!-- @TODO uncomment once backend is ready
                                            <div class="contacts-dropdown">
                                                <ContactsDropdown
                                                    :showContacts="showContacts"
                                                    @selected-contact="selectIndividualContact"
                                                />
                                            </div>
                                        -->
                                    </div>
                                    <span v-if="emailInvalid" class="error-msg px-1"
                                        >Enter a valid email</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div v-if="modalStep === 5" class="d-flex flex-column w-100">
                            <div class="d-flex flex-column text-start">
                                <p class="final-modal-title">You’re all set!</p>
                                <p class="final-modal-content">
                                    {{ inviteTextInfo(getEventsCounter) }}
                                    Once artists start to apply, you’ll be able to review them
                                    through the Booking Manager.
                                </p>
                            </div>
                        </div>
                    </template>
                    <template #modal-footer>
                        <div class="w-100 d-flex flex-column align-items-center">
                            <div v-if="modalStep === 1" class="w-50">
                                <b-button
                                    @click="createEvent"
                                    :disabled="disableBtn || disableCreateEventBtn"
                                    class="create-event-btn"
                                    slot="modal-footer"
                                >
                                    Create Events
                                </b-button>
                            </div>
                            <div v-if="modalStep === 6" class="w-50">
                                <b-button
                                    @click="modalStep = 2"
                                    :disabled="disableBtn || !selectedVenue"
                                    class="create-event-btn"
                                    slot="modal-footer"
                                >
                                    Add Event Address
                                </b-button>
                            </div>

                            <div v-if="modalStep === 2" class="w-50">
                                <div class="vibe-modal-btns">
                                    <b-button
                                        @click="goToBudgetStep"
                                        class="set-vibe-btn"
                                        :disabled="
                                            disableBtn ||
                                            !opportunityDetail ||
                                            opportunityDetail.length > 500
                                        "
                                        slot="modal-footer"
                                    >
                                        Add Event Description
                                    </b-button>
                                </div>
                            </div>
                            <div v-if="modalStep === 3" class="w-50">
                                <b-button
                                    @click="budgetModalStep"
                                    class="create-event-btn"
                                    :disabled="disableBtn || (!eventBudget && !hidePayout)"
                                    slot="modal-footer"
                                >
                                    Set the Payout
                                </b-button>
                            </div>
                            <div
                                v-if="modalStep === 4"
                                class="w-100 d-flex justify-content-center"
                            >
                                <div class="d-flex align-items-center w-50">
                                    <b-button
                                        v-if="
                                            !inviteSpecialArtist.length &&
                                            !relevantArtistsCount.length &&
                                            !privateOpportunity
                                        "
                                        @click="finalModalStep"
                                        :disabled="getDisabledBtn"
                                        class="invite-btn"
                                        slot="modal-footer"
                                    >
                                        Invite Artists Later
                                    </b-button>
                                    <b-button
                                        v-else
                                        @click="inviteArtist"
                                        :disabled="
                                            getDisabledBtn ||
                                            (privateOpportunity &&
                                                !(
                                                    inviteSpecialArtist.length +
                                                    relevantArtistsCount.length
                                                ))
                                        "
                                        class="invite-btn"
                                        slot="modal-footer"
                                    >
                                        {{ invitationLanguage }}
                                    </b-button>
                                </div>
                            </div>
                            <b-button
                                v-if="modalStep === 5"
                                @click="closeModal"
                                class="create-event-btn"
                                slot="modal-footer"
                            >
                                Close
                            </b-button>
                        </div>
                    </template>
                </b-modal>
                <b-modal
                    no-enforce-focus
                    centered
                    hide-header
                    id="edit-event-modal"
                    content-class="edit-event-modal"
                    size="lg"
                >
                    <div
                        @click="$bvModal.hide('edit-event-modal')"
                        class="close-modal-event justify-content-end"
                    >
                        <img :src="getIcon() + 'close-event-modal.svg'" />
                    </div>
                    <AddEventTitle
                        @updateEventData="updateEventData"
                        :eventInfo="eventInfo"
                        v-if="modalMode === 'addTitle'"
                    />
                    <AddEventTime
                        v-if="modalMode === 'addTime'"
                        @updateEventData="updateEventData"
                        :eventData="eventData"
                    />
                    <AddEventTags
                        @updateEventData="updateEventData"
                        :eventData="eventData"
                        v-if="modalMode === 'addTags'"
                    />
                    <AddEventDate
                        @updateEventData="updateEventData"
                        :eventInfo="eventInfo"
                        v-if="modalMode === 'addDate'"
                    />
                    <AddEventImage
                        @updateEventData="updateEventData"
                        :eventInfo="eventInfo"
                        v-if="modalMode === 'addImage'"
                    />
                    <p
                        class="cancel-btn"
                        @click="$bvModal.hide('edit-event-modal')"
                        slot="modal-footer"
                    >
                        Cancel
                    </p>
                </b-modal>
            </div>
            <div
                v-if="
                    (paginatedArtists && paginatedArtists.length) ||
                    (artistEvents && artistEvents.length)
                "
                class="events-container"
            >
                <!-- <hr style="color: #646464; height: 2px" />
                <div v-if="dataLoaded">
                    <booking-legend />
                    <BookingCalendar
                        v-if="width > 600"
                        :events.sync="getAllCalendarEvents"
                        @formatted-date="handleFormattedDate"
                        @show-modal="showModal"
                        @show-invite-modal="openCheckAvailsModal"
                        @filter-events="handleFilterEventsFromCal"
                    />
                </div>

                <div class="filter-and-cards">
                    <div class="event-filter">
                        <div class="event-count">{{ switchEventCount(filterStatus) }}</div>
                        <div class="d-flex align-items-center" v-if="width > 600">
                            <span class="filter-text">Showing</span>
                            <div
                                v-for="status in filter"
                                :key="status.id"
                                class="filter-group"
                            >
                                <input
                                    type="radio"
                                    class="radio-check"
                                    :id="status.id"
                                    :name="'statusGroup'"
                                    :checked="status.filterStatus === null"
                                    @change="changeStatusFilter(status)"
                                    autocomplete="off"
                                />
                                <label :for="status.id" class="filter-by-avails">{{
                                    status.label
                                }}</label>
                            </div>
                        </div>
                        <div class="mobile-select position-relative" v-if="width < 600">
                            <input
                                type="text"
                                readonly
                                class="mobile-option"
                                v-model="selectedValue"
                                @click="toggleOption"
                            />
                            <i class="fa fa-angle-down fa-2x" v-if="!optionList"></i>
                            <div v-if="optionList" class="option-list">
                                <div
                                    v-for="status in filter"
                                    :key="status.id"
                                    class="option-item"
                                    @click="selectOption(status)"
                                >
                                    {{ status.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr style="color: #646464; height: 2px" />
                    <div v-if="getLengthArtists > 15">
                        <Pagination
                            :currentPage="currentPage"
                            :totalPages="totalPages"
                            :visiblePagesCount="getLengthArtists"
                            @page-change="handlePageChange"
                        />
                    </div>
                </div> -->
                <div class="event d-flex">
                    <EventCard
                        v-for="(event, indx) in paginatedArtists"
                        :key="indx"
                        :event="event"
                        variant="venue"
                        @cta-clicked="(event) => onCardCtaClicked(event)"
                        @card-clicked="(event) => onCardCtaClicked(event)"
                    />
                    <EventCard
                        v-for="event in artistEvents"
                        :key="event.bid_artist_id"
                        :event="event"
                        variant="artist"
                        @cta-clicked="(event) => goToArtistEventPages(event)"
                        @card-clicked="(event) => goToArtistEventPages(event)"
                    />
                    <!-- <b-modal
                        no-enforce-focus
                        centered
                        hide-header
                        hide-footer
                        id="modal-delete-event-venue"
                        content-class="cancel-event-modal"
                        size="xl"
                    >
                        <p class="modal-title-text">You are about to delete this event</p>
                        <p class="modal-warning-text">
                            Are you sure you want to delete this event?
                        </p>
                        <div class="d-flex flex-column align-items-center">
                            <button
                                class="return-btn"
                                @click="$bvModal.hide('modal-delete-event-venue')"
                            >
                                No, Let's Go Back
                            </button>
                            <p class="cancel-btn" @click="deleteEvent" slot="modal-footer">
                                Yes, Delete This Event
                            </p>
                        </div>
                    </b-modal>
                    <b-modal
                        no-enforce-focus
                        centered
                        hide-header
                        hide-footer
                        id="modal-cancel-event-venue"
                        content-class="cancel-event-modal"
                        size="xl"
                    >
                        <p class="modal-title-text">
                            {{
                                !subscriptionMode
                                    ? 'You are about to cancel this event'
                                    : 'Need more events?'
                            }}
                        </p>
                        <p class="modal-warning-text">
                            {{
                                !subscriptionMode
                                    ? 'Are you sure you want to cancel?'
                                    : "You've reached the event limit for your current subscription. Access more as soon as you upgrade."
                            }}
                        </p>
                        <div class="modal-warning-wrapper">
                            <p class="modal-warning-text mb-0">
                                Continuing will cancel all scheduled artists.
                            </p>
                            <p class="modal-warning-text mb-0">
                                Any payments made will be reimbursed in accordance with
                                Hedlyner's
                            </p>
                            <a
                                href="/refunds-and-cancellation-policy"
                                class="modal-warning-text mb-0"
                                target="_blank"
                            >
                                Refunds and Cancellation Policy.
                            </a>
                        </div>
                        <div
                            v-if="!subscriptionMode"
                            class="d-flex flex-column align-items-center"
                        >
                            <button
                                class="return-btn"
                                @click="$bvModal.hide('modal-cancel-event-venue')"
                            >
                                No, Let's Go Back
                            </button>
                            <p class="cancel-btn" @click="cancelEvent" slot="modal-footer">
                                Yes, Cancel This Event
                            </p>
                        </div>
                        <div v-else class="d-flex flex-column align-items-center">
                            <button
                                class="return-btn"
                                :class="{ 'unlock-events': subscriptionMode }"
                                @click="goToSubscription"
                            >
                                Unlock more events
                            </button>
                            <p
                                class="cancel-btn"
                                @click="$bvModal.hide('modal-cancel-event-venue')"
                                slot="modal-footer"
                            >
                                I don't want more
                            </p>
                        </div>
                    </b-modal> -->
                </div>
                <hr style="color: #646464; height: 2px" />
                <div v-if="getLengthArtists > 15">
                    <Pagination
                        :currentPage="currentPage"
                        :totalPages="totalPages"
                        :visiblePagesCount="getLengthArtists"
                        @page-change="handlePageChange"
                    />
                </div>
            </div>
            <div v-else class="no-events-section">
                <p class="title">No Events Yet? Let’s Change That!</p>
                <p class="desc">
                    Your calendar is wide open—perfect for planning something unforgettable.
                    Why not start by creating a live music event? It’s easy, and you could be
                    setting the stage for the next big act.
                </p>
                <p class="desc">
                    Every empty day is an opportunity to bring music and community together.
                    Ready to make it happen? Click the button and take the first step toward
                    your next great event.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import EventCard from './parts/EventCard.vue'
    import AddEventTitle from './parts/AddEventTitle.vue'
    import AddEventTime from './parts/AddEventTime.vue'
    import AddEventTags from './parts/AddEventTags.vue'
    import AddEventDate from './parts/AddEventDate.vue'
    import AddEventImage from './parts/AddEventImage.vue'
    import LineChart from './chart-line/LineChart.vue'
    // import BookingCalendar from './parts/BookingCalendar.vue'
    import CheckAvailsCalendar from './parts/CheckAvailsCalendar.vue'
    import sortEventFunction from '@/mixins/sort-events/sort-events-function'
    import checkScreen from '../../mixins/check-screen'
    import sortByDateFunction from '../../mixins/sort-events/sort-by-date'
    import Pagination from '../search-result-artist/Pagination.vue'
    // TODO: uncomment once backend feature is ready
    // import ContactsDropdown from '@/composables/features/venue-booking/useVenueContacts.js'
    import useFormattedData from '@/composables/useFormattedData.js'
    import { EventMixin } from '../../mixins/event-list-calendar'
    import disabledBtnValidation from '../../mixins/submit-button-validation'
    // import BookingLegend from './parts/BookingLegend.vue'
    import SwitchToggle from '@/components/ui/toggle/Switch.vue'
    import SelectVenueAddress from './parts/create-event-steps/promoters/SelectVenueAddress.vue'

    const bidStatusDefinitions = {
        Null: null,
        New: 0,
        Process: 1,
        WaitApprove: 2,
        Confirmed: 3,
        Completed: 4,
        Cancelled: 5,
        Rejected: 6
    }
    const bidArtistStatusDefinitions = {
        Null: null,
        New: 0,
        SaveForLater: 1,
        Ignore: 2,
        Selected: 3,
        Rejected: 4
    }
    const URLS = {
        redirect: {
            opportunities: '/opportunities',
            makeOffer: '/make-offer',
            artistAdvance: '/booking-manager/artist/advance',
            artistWrapup: '/booking-manager/artist/wrap-up',
            artistCompleted: '/booking-manager/artist/completed-history'
        }
    }
    export default {
        name: 'EventListCalendar',
        mixins: [
            sortEventFunction,
            checkScreen,
            sortByDateFunction,
            EventMixin,
            disabledBtnValidation
        ],
        components: {
            EventCard,
            AddEventTitle,
            AddEventTime,
            AddEventTags,
            AddEventDate,
            AddEventImage,
            LineChart,
            CheckAvailsCalendar,
            // BookingCalendar,
            Pagination,
            // BookingLegend,
            SwitchToggle,
            SelectVenueAddress
            // TODO: uncomment once backend feature is ready
            // ContactsDropdown
        },
        props: {
            eventTags: {
                type: Array,
                default: () => []
            },
            minBudget: {
                type: Number
            },
            maxBudget: {
                type: Number
            },
            budgetMinValue: {
                type: Number
            },
            budgetMaxValue: {
                type: Number
            },
            budgetMode: {
                type: Boolean,
                default: false
            },
            eventInfo: {
                type: Object
            }
        },
        setup() {
            const { formatBigNumbers } = useFormattedData()
            return { formatBigNumbers }
        },
        methods: {
            goToArtistEventPages(event) {
                console.log(event)
                localStorage.clear()
                localStorage.setItem('eventId', event.event_id)

                if (event.artist_id === null) {
                    return (window.location.href = `${URLS.redirect.opportunities}/?opportunity=${event.event_id}`)
                }
                switch (event.event_status) {
                    case bidStatusDefinitions.New:
                        return (window.location.href = `${URLS.redirect.opportunities}/?opportunity=${event.event_id}`)
                    case bidStatusDefinitions.Process:
                        if (
                            event.event_artist_status === bidArtistStatusDefinitions.Selected
                        ) {
                            return (window.location.href = `${URLS.redirect.artistAdvance}/${event.artist_id}`)
                        }
                        localStorage.setItem('bidArtist', event.bid_artist_id)
                        return (window.location.href = `${URLS.redirect.opportunities}/?opportunity=${event.event_id}`)
                    case bidStatusDefinitions.WaitApprove:
                        if (
                            event.event_artist_status !== bidArtistStatusDefinitions.Selected
                        ) {
                            localStorage.setItem('bidArtist', event.bid_artist_id)
                            return (window.location.href = `${URLS.redirect.makeOffer}/${event.artist_id}`)
                        }
                        return (window.location.href = `${URLS.redirect.artistAdvance}/${event.artist_id}`)
                    case bidStatusDefinitions.Confirmed:
                        return (window.location.href = `${URLS.redirect.artistWrapup}/${event.artist_id}`)
                    case bidStatusDefinitions.Completed:
                        return (window.location.href = `${URLS.redirect.artistCompleted}/${event.event_id}`)
                    default:
                        return
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .contacts-dropdown {
        position: absolute;
        right: 15%;
    }
    .text-start {
        padding: 0px 70px 0px 70px;
    }
    .payout-input-wrapper {
        @include flex-col;
        gap: 16px;
        padding-bottom: 208px;
    }
    .event-type-input-wrapper {
        @include flex-row;
        gap: 16px;
        align-items: center;
        padding-bottom: 28px;

        .event-type-switch-label {
            @include flex-row;
            align-items: center;
            gap: 16px;

            .switch-label {
                color: #8b8b8b;
                @include base-font-22;
                line-height: 120%;
                letter-spacing: -0.22px;
            }
        }

        .invite-artist-description {
            color: #acacac;
            @include base-font-16;
            font-weight: 550;
            line-height: 125%;
        }
    }
    .payout-switch-label {
        @include flex-row;
        gap: 16px;
        .switch-label {
            color: $darker-grey;
            @include base-font-22;
            line-height: 120%;
            letter-spacing: -0.22px;
        }
    }
    .switch-label {
        color: #8b8b8b;
        @include base-font-22;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .budget-input {
        @include flex-col;
        gap: 6px;
    }
    .modal-contents-main {
        @include flex-col;
        gap: 16px;
    }
    .vibe-pills-wrapper {
        @include flex-row;
        gap: 8px;
        overflow-x: scroll;
    }
    .vibe-pills-wrapper::-webkit-scrollbar {
        display: none;
    }

    .vibe-pills-wrapper {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .vibe-pills {
        @include flex-row;
        justify-content: center;
        align-items: center;
        padding: 7px 30px 9px 30px;
        border-radius: 100px;
        border: 1px solid #8b8b8b;
        background: #262626;
        font-size: 16px !important;
    }
    .opportunity-detail-input::-webkit-scrollbar {
        width: 8px;
    }
    .opportunity-detail-input::-webkit-scrollbar-track {
        background-color: none;
    }
    .opportunity-detail-input::-webkit-scrollbar-thumb {
        max-height: 64px;
        border-radius: 8px;
        background: #8b8b8b;
    }
    .opportunity-detail-input-wrapper {
        @include flex-row;
        justify-content: space-between;
        width: 100%;
        max-width: 887px;
    }
    .opportunity-detail-input {
        max-width: 887px;
        min-height: 171px;
        padding: 12px 15px 15px 15px;
        align-items: flex-start;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        color: #dedede;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .opportunity-detail-input::placeholder {
        color: #646464;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .view-link {
        color: inherit;
    }
    .dollar-sign {
        color: #dedede;
        position: absolute;
        font-size: 16px;
        top: 49%;
        left: 5%;
    }
    .event-status-future {
        border-radius: 100px;
        border: 1px solid #8b8b8b;
        padding: 12px 15px 15px;
        background: #262626;
    }

    .set-vibe-btn {
        width: 100%;
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
        border: 0;
        min-width: 290px;
        text-align: center;
    }
    .vibe-modal-btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }

    .disabled-btn {
        opacity: 0.6;
    }

    .disabled-invite-btn {
        background: #262626 !important;
        border: 1px solid #8b8b8b !important;
        color: #8b8b8b !important;
    }

    .mobile-budget {
        display: flex;
        gap: 16px;
        justify-content: space-between;
        width: 100%;
    }

    .cancelled-lines {
        width: 50px;
        height: 50px;
        background: url(/images/icons/booked-purple.svg) no-repeat;
        background-size: 50px 50px;
        position: absolute;
        bottom: 8px;
        right: 82px;
    }

    .booking-manager-container {
        max-width: 1135px;
        margin-left: auto;
        margin-right: auto;
    }

    .cancel-btn {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
        margin: 0;
    }

    .modal-title-text {
        color: #f5f5f5;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
        text-align: center;
    }

    .modal-warning-wrapper {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        max-width: 620px;
        @include flex-col;
        align-items: center;
        justify-content: center;
    }

    .modal-warning-text {
        color: #acacac;
        text-align: center;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
        text-align: center;
    }

    .return-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        @include base-font-18;
        font-weight: 650;
        line-height: 120%;
        border: 0;
        max-height: 90px;
        margin-bottom: 24px;
        margin-top: 40px;
    }

    .unlock-events {
        width: 100%;
        max-width: 100%;
    }

    .event-settings img {
        cursor: pointer;
    }
    .event-count {
        color: #8b8b8b;
        @include base-font-32;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .filter-and-cards {
        max-width: 1048px;
    }
    .event-filter {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-wrap: nowrap;
    }
    .mobile-option {
        display: flex;
        padding: 12px 12px 16px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        overflow: hidden;
        color: #dedede;
        text-overflow: ellipsis;
        white-space: nowrap;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .option-list {
        padding: 12px 16px 16px 16px;
        @include flex-col;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        position: static;
    }
    .option-item {
        overflow: hidden;
        color: #8b8b8b;
        text-overflow: ellipsis;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .pills-container {
        gap: 10px;
        max-height: 90px;
        overflow-y: scroll;
        flex-wrap: wrap;
    }

    .pills-container::-webkit-scrollbar {
        width: 0;
    }

    .specific-artists-content {
        gap: 10px;
        margin-bottom: 25px;
    }

    .copy-btn {
        display: flex;
        padding: 10px 25px 11px 20px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: #262626;
        margin-left: 10px;
    }

    .copy-btn img {
        max-width: 24px;
        max-height: 24px;
    }

    .copy-btn p {
        color: #cdeb09;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
        margin: 0;
        cursor: pointer;
    }

    .artists-pills {
        padding: 5px 15px;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        gap: 10px;
    }

    .artists-pills p {
        color: #cdeb09;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        margin: 0;
    }

    .invite-artist-image {
        max-width: 28px;
        max-height: 28px;
        border-radius: 50%;
    }

    .remove-email {
        cursor: pointer;
    }

    .enter-artists {
        position: relative;
        display: flex;
        gap: 10px;
    }

    .specific-artists {
        margin-top: 20px;
    }

    .specific-artists button {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        border: 0;
        color: #000000;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
    }

    .invite-artist {
        overflow: hidden;
        color: #cdeb09;
        text-overflow: ellipsis;
        whitespace: nowrap;
        @include base-font-22;
        line-height: 120%;
        letter-spacing: -0.22px;
        margin: 0;
        min-width: max-content;
    }

    .error-msg {
        color: #ed3c0d !important;
    }

    .specific-artists input {
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 15px 15px 15px;
        width: 100%;
        color: #dedede;
        @include base-font-16;
        font-weight: 700;
        line-height: 125%;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    .error-text {
        color: #f03232;
        margin: 5px 0 0 0;
    }

    .duration-field {
        background: #262626;
        border: 1.5px solid #8b8b8b;
        border-radius: 12px;
        color: #fff;
        padding-left: 20px;
        margin-bottom: 10px;
    }

    .other-name-status {
        color: #000;
        @include base-font-18;
        font-weight: 550;
        line-height: 120%;
        margin: 0;
    }

    .status-cancelled {
        padding: 12px 20px 15px;
        background: #ba87ff;
        border-radius: 100px;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .status-complete {
        padding: 12px 20px 15px;
        background: #464646;
        border-radius: 100px;
        display: flex;
        gap: 10px;
        align-items: center;
        cursor: pointer;
    }

    .artists-container {
        margin: 10px 0;
        max-width: 650px;
        overflow-x: scroll;
    }

    .artists-container::-webkit-scrollbar {
        width: 0;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .line-chart-container {
        max-width: 440px;
        margin-top: 20px;
    }

    .min-max-value {
        @include flex-col;
        gap: 6px;
    }

    .label-value {
        color: #acacac;
        @include base-font-12;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }

    .budget-value-input {
        color: #dedede;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        padding: 12px 20px 15px 20px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        max-width: 150px;
        max-height: 51px;
        @include flex-row;
        align-items: center;
    }

    .budget-value {
        position: relative;
        color: #dedede;
        overflow: hidden;
        text-overflow: ellipsis;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        border: none;
        padding-top: 4px;
    }

    .budget-value:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }

    .invite-artist-content {
        gap: 10px;
    }

    .invite-artist-title {
        color: #dedede;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .invite-artist-list {
        overflow: hidden;
        color: #ba87ff;
        text-overflow: ellipsis;
        @include base-font-22;
        line-height: 120%;
        letter-spacing: -0.22px;
    }

    .contact-artist,
    .contact-artist-selected {
        @include flex-row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-bottom: 0px;
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .contact-artist {
        border: 1px solid #acacac;
        color: #acacac;
    }

    .contact-artist-selected {
        border: 1px solid #ba87ff;
        color: #ba87ff;
    }

    .hedlyner-artists {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #acacac;
        color: #acacac;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .hedlyner-artists-selected {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #ba87ff;
        color: #ba87ff;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .artist-selected {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #ba87ff;
        color: #ba87ff;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
        gap: 8px;
        display: flex;
        align-items: center;
    }

    .artist-selected span {
        text-decoration: underline;
    }

    .artist-selected p {
        margin: 0;
    }

    .artist-location {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #acacac;
        background: #262626;
        color: #acacac;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .artist-location p {
        margin: 0;
    }

    .artist-location span {
        text-decoration: underline;
    }

    .invite-artist-content {
        gap: 10px;
    }

    .invite-artist-title {
        color: #dedede;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .invite-artist-description {
        color: #acacac;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }

    .invite-artist-list {
        overflow: hidden;
        color: #ba87ff;
        text-overflow: ellipsis;
        @include base-font-22;
        line-height: 120%;
        letter-spacing: -0.22px;
        margin: 0;
    }

    .artist-selected {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #ba87ff;
        color: #ba87ff;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .artist-location {
        padding: 6px 20px 8px 15px;
        border-radius: 100px;
        border: 1px solid #acacac;
        background: #262626;
        color: #acacac;
        @include base-font-14;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        cursor: pointer;
    }

    .event {
        margin-top: 50px;
        @include flex-row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 20px;
        flex-wrap: wrap;
    }

    .filter-text {
        color: #646464;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    input[type='radio'] {
        height: 20px;
        width: 20px;

        background: inherit;
        appearance: none;
        border: 1px solid #8b8b8b;
        border-radius: 50%;
    }
    input[type='radio']:checked {
        accent-color: #cdeb09;
        appearance: auto;
    }
    .filter-group {
        display: flex;
        padding: 10px 8px;
        align-items: center;
        gap: 8px;
    }
    .filter-by-avails {
        color: #8b8b8b;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .fa {
        bottom: 23%;
        color: #8b8b8b;
        left: 91%;
        position: absolute;
    }

    .page-title {
        color: #dedede;
        font-family: Domine;
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px;
    }

    .header-block {
        padding: 50px;
        padding-left: 0;
        border-bottom: 1px solid #262626;
    }

    .event-list {
        background: #000000;
    }

    .events-container {
        padding-top: 25px;
        padding-bottom: 140px;
    }
    .no-events-section {
        width: 100%;
        max-width: 692px;
        @include flex-col;
        align-items: flex-start;
        justify-content: center;
        gap: 20px;
        margin-top: 40px;
    }
    .title {
        color: #dedede;
        @include base-font-24;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: -0.48px;
    }
    .desc {
        color: #8b8b8b;
        @include base-font-16;
        font-weight: 400;
        line-height: 24px;
    }

    .event {
        display: flex;
        justify-content: flex-start;
        border-radius: 15px;
        margin-bottom: 25px;
    }

    .header-wrapper {
        display: flex;
        justify-content: flex-start;
        gap: 16px;
        align-items: center;
    }
    .check-avails {
        display: flex;
        padding: 8px 12px;
        align-items: center;
        gap: 4px;
        border-radius: 120px;
        background: #cdeb09;
        color: #262626;
        @include base-font-14;
        line-height: 115%;
        letter-spacing: 0.14px;
        border: none;
    }

    .event-status {
        padding: 12px 15px 15px;
        background: #464646;
        border-radius: 100px;
    }

    .status-name {
        @include base-font-18;
        font-weight: 600;
        line-height: 120%;
        hanging-punctuation: first last;
        list-style-position: outside;
        padding: 0;
        color: #8b8b8b;
        margin: 0;
        cursor: pointer;
    }

    .event .event-time {
        @include base-font-20;
        font-weight: 600 !important;
        line-height: 120% !important;
        letter-spacing: -0.02em !important;
        color: #8b8b8b !important;
    }

    .event-budget {
        @include base-font-20;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.02em;
        color: #646464;
        margin: 0;
    }

    .applied-artist {
        @include base-font-16;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.02em;
        color: #ba87ff;
    }

    .booked-artist {
        color: #8b8b8b;
        @include base-font-16;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.32px;
    }

    .event-tags-row {
        width: 100%;
        overflow-x: scroll;
        flex-direction: row;
    }

    .event-tags-row::-webkit-scrollbar {
        width: 0;
    }

    .event-tags {
        background: #262626;
        border: 1px solid #646464;
        border-radius: 100px;
        margin-right: 7px;
        padding: 2px 10px 4px;
        max-height: 30px;
        min-width: max-content;
        margin-left: auto;
    }

    .event-tags span {
        @include base-font-14;
        font-weight: 700;
        font-size: 14px;
        line-height: 130%;
        hanging-punctuation: first last;
        list-style-position: outside;
        padding: 0;
        color: #646464;
        padding: 6px 10px;
        margin: 0;
    }

    .arrow {
        max-width: 24px;
        max-height: 24px;
    }

    .artist-img {
        width: 28px;
        height: 28px;
    }

    .artist-name {
        color: #8b8b8b;
        @include base-font-16;
        font-weight: 600;
        line-height: 160%;
        letter-spacing: -0.16px;
        margin: 0;
    }

    .artist-name-applied {
        @include base-font-16;
        font-weight: 600;
        line-height: 160%;
        letter-spacing: -0.16px;
        margin: 0;
        color: #ba87ff;
        text-decoration: none;
    }

    .artist-container {
        display: flex;
        padding: 5px 12px 5px 5px;
        align-items: flex-start;
        gap: 10px;
        border-radius: 100px;
        border: 1px solid #8b8b8b;
        background: #262626;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        margin-right: 8px;
        min-width: fit-content;
    }

    .artist-container-applied {
        display: flex;
        padding: 5px 12px 5px 5px;
        align-items: flex-start;
        gap: 10px;
        border-radius: 100px;
        border: 1px solid #ba87ff;
        background: #262626;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        margin-right: 8px;
        color: #ba87ff;
        min-width: fit-content;
    }

    .status-advance {
        border-radius: 100px;
        padding: 12px 15px 15px;
        background: #cb9b1f;
    }

    .status-advance p {
        color: #000000;
    }

    .status-avails-checked {
        background: #d7eb5a;
    }

    .status-avails-checked p {
        color: #000000;
    }

    .status-book {
        background: #c9cd00;
    }

    .status-book p {
        color: #000000;
    }

    .status-wrap-up {
        border-radius: 100px;
        padding: 12px 15px 15px;
        background: #d188bf;
    }

    .status-wrap-up p {
        color: #000000;
    }

    .all-status {
        gap: 6px;
    }

    .modal-event-title {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        text-transform: none !important;
        margin-bottom: 0px;
    }

    .gray-text {
        color: #8b8b8b;
    }

    .gray-subtitle {
        color: #8b8b8b;
        font-size: 20px;
    }

    .multi-line {
        white-space: pre-line;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 641px;
    }

    .modal-event-text {
        margin-bottom: 0px;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }

    .modal-subtitle {
        margin-top: 8px;
        margin-bottom: 40px;
        max-width: 493px;
    }

    .create-event-btn {
        display: flex;
        padding: 13px 40px 15px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border: 0;
        flex-shrink: 0;
        border-radius: 100px;
        background: #cdeb09;
        color: #262626;
        text-align: center;
        @include base-font-22;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.22px;
        width: 100%;
        max-height: 45px;
    }
    .create-event-btn,
    .set-vibe-btn,
    .invite-btn {
        border: none;

        &:disabled {
            color: #646464;
            background: #464646;
            cursor: not-allowed;
        }
    }

    .invite-btn {
        max-width: 662px;
        width: 100%;
        display: flex;
        padding: 13px 40px 15px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        border-radius: 100px;
        background: #cdeb09;
        color: #262626;
        text-align: center;
        @include base-font-22;
        font-weight: 600;
        line-height: 120%;
        letter-spacing: -0.22px;
    }

    .cancel-btn {
        color: #8b8b8b;
        text-align: center;
        @include base-font-22;
        line-height: 120%;
        letter-spacing: -0.44px;
        cursor: pointer;
        text-decoration: underline;
    }

    .apply-btn {
        color: #8b8b8b;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }

    .check-btn {
        color: #8b8b8b;
        @include base-font-12;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }

    .final-modal-title {
        color: #dedede;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .final-modal-content {
        color: #acacac;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
        max-width: 510px;
    }

    .checked-input {
        border-radius: 24px;
        border: 1.5px solid #646464;
        min-width: 24px;
    }

    @media (max-width: 1100px) {
        .event-filter {
            overflow-y: scroll;
            justify-content: flex-start;
        }
    }

    @media (max-width: 600px) {
        .event-filter {
            @include flex-col;
            gap: 16px;
            justify-content: flex-start;
            align-items: flex-start;
        }
        .mobile-select {
            @include flex-col;
            align-items: flex-start;
            gap: 6px;
            align-self: stretch;
        }
        .artist-container {
            padding: 5px;
        }

        .artist-container-applied {
            padding: 5px;
        }

        h1 {
            font-size: 22px;
        }

        .header-block {
            padding: 0;
        }

        .event-budget {
            font-size: 16px;
        }

        .status-name {
            text-align: center;
            font-size: 16px;
        }

        .event-status {
            padding: 7px 20px 10px 20px;
            flex: 1 0 0;
        }

        .check-avails {
            text-align: center;
            width: 100%;
        }

        .event .event-time {
            font-size: 16px !important;
        }
    }
</style>

<style>
    .modal-create-event {
        min-width: 1194px;
        border-radius: 15px;
        border: 1px solid rgba(255, 255, 255, 0.14);
        background: #262626;
        position: relative;
    }

    .close-modal-event {
        cursor: pointer;
        @include flex-row;
        justify-content: center;
        gap: 8px;
        padding: 10px 16px;
    }

    .cancel-btn-label {
        color: #cdeb09;
        @include base-font-16;
        line-height: 125%; /* 20px */
        text-transform: capitalize;
    }

    .cancel-icon {
        width: 20px;
        height: 20px;
    }

    .new-design-header {
        width: 228px;
        padding: 10px 16px;
        @include flex-row;
        justify-content: center;
        gap: 24px;
    }

    .create-event-title {
        color: #dedede;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        margin-bottom: 0px;
    }

    .back-btn {
        background: none;
        border: none;
    }

    .edit-event-modal {
        background: #262626;
        border-radius: 20px;
        display: inline-flex;
        justify-content: center;
        padding: 40px 80px 0;
    }

    .line-chart-container .vue-slider-dot-handle {
        background: #cdeb09;
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0px;
    }

    .line-chart-container .vue-slider-rail {
        background-color: #acacac;
        border-radius: 15px;
        height: 1px;
    }

    .line-chart-container .slider-select .vue-slider-process {
        background-color: yellow;
        background: #d7eb5a;
        border-radius: 10px;
        cursor: pointer;
    }

    @media (max-width: 600px) {
        .edit-event-modal {
            padding: 16px 16px 0;
        }
    }
</style>
